import styled from "styled-components";

export const ModalOverlay = styled.div`
  inset: 0;
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: rgba(25, 25, 25, 0.75) !important;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: var(--black-200) !important;
  border: none !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
  width: 42rem;
  height: 90vh;
  background: transparent;
  border-radius: 4px;

  button {
    border-radius: 2.5rem;
    padding: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: var(--black-400);
    color: var(--white);
    font-size: 0.8rem;
    font-family: Inter;
    border-radius: 4px;
    padding: 0.55rem;
    margin-bottom: 0.5rem;
    transition: background 0.4s;

    &:hover {
      background-color: var(--black-100);
    }
  }

  .gallery {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 1rem;
  top: 1rem;
  width: 3rem;
  height: 3rem;
`;

export const Body = styled.div`
  position: relative;

  > button {
    position: absolute;
    bottom: 7rem;
    right: 3rem;
    background-color: var(--primary);
    width: 1.875rem;
    height: 1.875rem;
    border-radius: 4px;
    padding: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    height: 23.125rem;
    object-fit: contain;
  }
`;

export const Caption = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 0.7rem;

  span {
    align-self: stretch;
    padding: 0.5rem 1.1rem;
    border-radius: 4px;
    background: var(--black-300);
    font-family: DM Sans;
    font-size: 0.9rem;
  }
`;

export const InfoContainer = styled.div`
  position: absolute;
  bottom: 6.25rem;
  right: 0;
  border-radius: 4px;
  background: var(--black-300);
  padding: 0.7rem;
  max-width: 12.5rem;
  font-family: DM Sans;
  text-align: left;

  > div {
    margin-bottom: 0.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Title = styled.span`
  font-size: 0.875rem;
  color: var(--grey-100);
`;

export const Subtitle = styled.span`
  font-family: DM Sans;
  font-size: 1rem;
  line-height: 1.5rem;
  color: var(--white);
  overflow: hidden;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
`;
